import gsap from "gsap";
import DefaultBlock from "/scripts/default/block";
import { watchPreferredMotion } from "../../../../../utils/helpers/watchPreferredMotion";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Draggable } from "gsap/Draggable";

gsap.registerPlugin(ScrollTrigger);

export default class UIFlower extends DefaultBlock {
	init() {
		this.DOM = {
			flowerWrapper: this.block.querySelector("#ui-flower-wrapper"),
			flower: this.block.querySelector("#ui-flower-shape"),
			flowerGradientPath: this.block.querySelector("path:first-child"),
			gradientNight: this.block.querySelector("linearGradient:nth-child(1)"),
			gradientLight: this.block.querySelector("linearGradient:nth-child(2)"),
		};
		this.state = {};

		this.buildOn();
		this.animate();
	}

	initEvents() {
		document.addEventListener("setLightMode", () => {
			this.DOM.flowerGradientPath.setAttribute(
				"fill",
				`url(#${this.DOM.gradientLight.getAttribute("id")})`
			);
		});

		document.addEventListener("setNightMode", () => {
			this.DOM.flowerGradientPath.setAttribute(
				"fill",
				`url(#${this.DOM.gradientNight.getAttribute("id")})`
			);
		});
	}

	buildOn() {
		gsap.set(this.block, { autoAlpha: 1 });

		watchPreferredMotion(() => {
			const buildOnTl = gsap.timeline({
				id: "flower-build-on",
				scrollTrigger: {
					trigger: this.block,
					start: "top 85%",
				},
			});

			buildOnTl.from(this.DOM.flower, {
				scale: 0,
				transformOrigin: "50% 50%",
				duration: 0.4,
				ease: "power3.out",
			});

			// GSDevTools.create();
		});
	}

	animate() {
		watchPreferredMotion(() => {
			const tl = gsap
				.timeline({
					scrollTrigger: {
						trigger: this.DOM.flower,
						start: "top bottom",
						end: "bottom top",
						scrub: 2,
					},
				})
				.to(this.DOM.flower, {
					rotation: 360 * 3,
					transformOrigin: "50% 50%",
					ease: "power1.inOut",
					duration: 0.6,
				});

			Draggable.create(this.DOM.flowerWrapper, {
				type: "rotation",
				inertia: true,
				throwResistance: 2000,
			});
		});
	}
}
